import * as yup from 'yup';
// Now make a yup schema for this type
var configSchema = yup.object().shape({
    apiUrl: yup.string().required(),
    logRefreshRate: yup.number().required()
});
var accountsConfigSchema = yup.object().shape({
    url: yup.string().required(),
    name: yup.string().required(),
    shortCode: yup.string().required(),
    color: yup.string().required()
});
var amazonCognitoConfigSchema = yup.object().shape({
    region: yup.string().required(),
    userPoolId: yup.string().required(),
    userPoolAppClientId: yup.string().required()
});
var windowEnvSchema = yup.object().shape({
    config: configSchema,
    accounts: yup.array().of(accountsConfigSchema).min(1),
    amazonCognito: amazonCognitoConfigSchema
});
export var loadWindowEnv = function () {
    var windowEnv = window.env;
    windowEnvSchema.validateSync(windowEnv);
    return windowEnv;
};
//# sourceMappingURL=window-env.js.map